import { RouteOptionsById, router, RouterIds, redirect } from "@vixi/router";

const routeId = "/" satisfies RouterIds;
const Route = router.routesById[routeId];

export const IndexPageOptions: RouteOptionsById<typeof routeId> = {
  loader: () => {
    throw redirect({ to: "/dashboard" });
  },
};
